<div class="row justify-content-center align-items-center mt-3 raise-complaint-responsive-wrapper">
  <!-- Toast Message Block -->
  <div *ngIf="showToast" class="toast-container">
    <div [ngClass]="['toast-message', toastType === 'success' ? 'toast-success' : 'toast-error']">
      <div class="toast-content">
        <div class="toast-text">
          <div class="toast-title" *ngIf="toastTitle">{{ toastTitle }}</div>
          <div class="toast-message-text">{{ toastMessageText }}</div>
        </div>
        <span class="material-symbols-outlined f-24 cursor-pointer" tabindex="0" (click)="closeToast()"
          (keypress)="closeToast()" title="Close">close</span>
      </div>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-center">
      <img src="assets/images/edu-logo.svg" alt="{{ genericMessage['G0001'] }}" class="img-fluid" />
    </div>
  </div>
  <div class="col-11 px-0 responsive-main-col">
    <!-- <div class="main-card card"> -->
    <div class="card-body responsive-card-body">
      <hr class="horizontal-line" />
      <div class="content responsive-content">
        <div class="heading-content mb-3">
          <h4 class="title font-weight-600">PUBLIC COMPLAINT FORM</h4>
        </div>
        <form [formGroup]="complaintForm" class="responsive-form">
          <!-- complainant info end-->
          <div class="license-wrapper border-box mb-3">
            <div class="license-header d-flex justify-content-between align-items-center"
              (click)="Complainants = !Complainants" [ngClass]="{'expanded': Complainants, 'collapsed': !Complainants}">
              <h5 class=" mb-0">Complainant Information</h5>
              <button type="button" class="toggle-btn" aria-label="Toggle" [attr.aria-expanded]="!Complainants"
                (click)="$event.stopPropagation(); Complainants = !Complainants">
                <span class="toggle-icon">
                  <i class="fas fa-chevron-up" *ngIf="Complainants" aria-hidden="true"></i>
                  <i class="fas fa-chevron-down" *ngIf="!Complainants" aria-hidden="true"></i>
                </span>
              </button>
            </div>
            <div *ngIf="Complainants" class="section-body p-3 border-box-section">
              <div>
                <p>Please enter the name of the individual submitting this complaint. Only one complainant may be
                  listed.
                  If multiple people are involved, each person must submit their own separate complaint or be listed
                  by the complainant as a witness if they have asked one person to submit on behalf of all parties.
                </p>
              </div>
              <div ref="component"
                class="formio-component formio-component-htmlelement formio-component-veteranContent app-para"
                id="env8sgc">
                <p class="formio-component-htmlelement mt-2 mb-4 app-para blue-bg">
                  Email verification is required before you may submit the Complaint. Click on the Complainant Email
                  Address textbox below, enter your email address, and then click Send Verification Code to receive a
                  one-time password (OTP) and complete the verification process.
                </p>
              </div>
              <div class="mb-4">
                <div class="d-flex mb-3 flex-wrap responsive-row">
                  <div class="col-12 col-md-6 col-lg-3 pl-1  d-flex flex-column responsive-col">
                    <div class="form-label">Complainant First Name<span class="text-red">*</span></div>
                    <input class="form-control" [placeholder]="placeholderMessage['P0001']" type="text" tabindex="0"
                      id="input_raiseacomplaint_complainant_first_name" formControlName="complainantFirstName" maxlength="30"
                      minlength="2" required aria-label="Enter Complainant First Name" aria-required="true"
                      [attr.aria-invalid]="complaintForm.get('complainantFirstName')?.touched && complaintForm.get('complainantFirstName')?.invalid ? 'true' : null"
                      [attr.aria-describedby]="complaintForm.get('complainantFirstName')?.touched && complaintForm.get('complainantFirstName')?.invalid ? 'complainantFirstName-error' : null"
                      (input)="onComplainantFirstNameInput($event)" (blur)="checkForTrailingSpace($event, 'complainantFirstName')"
                      (keydown.enter)="$event.preventDefault()"
                      [ngClass]="{'is-invalid-error': complaintForm.get('complainantFirstName')?.touched && complaintForm.get('complainantFirstName')?.invalid}" />
                    <div *ngIf="
                  complaintForm.get('complainantFirstName')?.touched && complaintForm.get('complainantFirstName')?.errors as errors
                ">
                      <div id="div_raiseacomplaint_complainant_first_name_error_required" *ngIf="errors['required']"
                        class="text-danger mt-1 err-font">
                        {{ errorMessage['M0001'] }}</div>
                      <div id="div_raiseacomplaint_complainant_first_name_error_pattern"
                        *ngIf="!errors['required'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                        class="text-danger mt-1 err-font">
                        {{ errorMessage['M0157'] }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-3  pl-1 d-flex flex-column responsive-col">
                    <div class="form-label">Complainant Last Name<span class="text-red">*</span></div>
                    <input class="form-control" [placeholder]="placeholderMessage['P0003']" type="text" tabindex="0"
                      id="input_raiseacomplaint_complainant_last_name" formControlName="complainantLastName" maxlength="30"
                      minlength="2" required aria-label="Enter Complainant Last Name" aria-required="true"
                      [attr.aria-invalid]="complaintForm.get('complainantLastName')?.touched && complaintForm.get('complainantLastName')?.invalid ? 'true' : null"
                      [attr.aria-describedby]="complaintForm.get('complainantLastName')?.touched && complaintForm.get('complainantLastName')?.invalid ? 'complainantLastName-error' : null"
                      (input)="onComplainantNameInput($event)" (blur)="checkForTrailingSpace($event, 'complainantLastName')"
                      (keydown.enter)="$event.preventDefault()"
                      [ngClass]="{'is-invalid-error': complaintForm.get('complainantLastName')?.touched && complaintForm.get('complainantLastName')?.invalid}" />
                    <div *ngIf="
                  complaintForm.get('complainantLastName')?.touched && complaintForm.get('complainantLastName')?.errors as errors
                ">
                      <div id="div_raiseacomplaint_complainant_last_name_error_required" *ngIf="errors['required']"
                        class="text-danger mt-1 err-font">
                        {{ errorMessage['M0004'] }}</div>
                      <div id="div_raiseacomplaint_complainant_last_name_error_pattern"
                        *ngIf="!errors['required'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                        class="text-danger mt-1 err-font">
                        {{ errorMessage['M0157'] }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-3 pl-1 d-flex flex-column responsive-col">
                    <div class="form-label" id="label_raiseacomplaint_complainant_email">Complainant Email Address<span
                        class="text-red">*</span></div>
                    <input class="form-control pr-5" [placeholder]="placeholderMessage['P0126']" readonly
                      formControlName="complainantEmail" id="input_raiseacomplaint_complainant_email" tabindex="0"
                      aria-label="Complainant Email Address"
                      aria-labelledby="label_raiseacomplaint_complainant_email button_raiseacomplaint_complainant_email_edit"
                      (click)="openEditModal('primaryEmail')"
                      (keydown.enter)="openEditModal('primaryEmail'); $event.preventDefault();"
                      (keydown.space)="openEditModal('primaryEmail'); $event.preventDefault();" />
                    <div class="input-group-append edit-icon-position">
                      <span class="icon-holder">
                        <button class="btn p-0" tabindex="0" title="Edit Email" aria-label="Edit Email"
                          id="button_raiseacomplaint_complainant_email_edit" (click)="openEditModal('primaryEmail')"
                          (keydown.enter)="openEditModal('primaryEmail'); $event.preventDefault();"
                          (keydown.space)="openEditModal('primaryEmail'); $event.preventDefault();" role="button">
                          <img src="../../../../assets/images/neveda-images/Edit.svg" alt="Edit" srcset="">
                        </button>
                      </span>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-3 pl-1 d-flex flex-column responsive-col">
                    <div class="form-label">Complainant Phone Number<span class="text-red">*</span></div>
                    <input class="form-control " [placeholder]="placeholderMessage['P0102']" type="text"
                      id="input_raiseacomplaint_complainant_phone_number" formControlName="complainantPhoneNumber"
                      required aria-required="true"
                      [attr.aria-invalid]="(complaintForm.get('complainantPhoneNumber')?.touched && complaintForm.get('complainantPhoneNumber')?.invalid) || phoneExists ? 'true' : null"
                      [attr.aria-describedby]="(complaintForm.get('complainantPhoneNumber')?.touched && complaintForm.get('complainantPhoneNumber')?.invalid) || phoneExists ? 'complainantPhoneNumber-error' : null"
                      tabindex="0" (input)="formatPhoneNumber($event)" (focus)="isPhoneFocused = true"
                      (blur)="isPhoneFocused = false; checkPhone()" (keydown.enter)="$event.preventDefault()"
                      numbersOnly [ngClass]="{
                                      'is-invalid-error':
                                        (complaintForm.get('complainantPhoneNumber')?.touched && complaintForm.get('complainantPhoneNumber')?.invalid) || (phoneExists && !isPhoneFocused)
                                    }" />
                    <div
                      *ngIf="complaintForm.get('complainantPhoneNumber')?.touched && complaintForm.get('complainantPhoneNumber')?.errors as errors">
                      <div id="div_raiseacomplaint_complainant_phone_number_error_required" *ngIf="errors['required']"
                        class="text-danger mt-1 err-font">{{ errorMessage['M0016'] }}</div>
                      <div id="div_raiseacomplaint_complainant_phone_number_error_pattern"
                        *ngIf="!errors['required'] && errors['pattern']" class="text-danger mt-1 err-font">
                        {{ errorMessage['M0017'] }}
                      </div>
                    </div>
                    <div id="div_raiseacomplaint_complainant_phone_number_error_exists" *ngIf="phoneExists"
                      class="text-danger mt-1 err-font">
                      The phone number entered is already on file.
                    </div>
                  </div>
                </div>
                <hr class="horizontal-line" />
                <div class="d-flex mb-3 flex-wrap responsive-row">
                  <div class="col-12 col-md-6 col-lg-3 d-flex flex-column pl-1 responsive-col">
                    <div class="form-label">Complainant Street Address<span class="text-red">*</span></div>
                    <input class="form-control " [placeholder]="placeholderMessage['P0011']" type="text"
                      id="input_raiseacomplaint_complainant_street_address" formControlName="complainantStreetAddress"
                      tabindex="0" class="Inputs form-control text-capitalize" minlength="3" maxlength="60" required
                      (input)="onStreetAddressInput($event)" (blur)="onFieldBlur($event, 'complainantStreetAddress')"
                      (keydown.enter)="$event.preventDefault()"
                      [ngClass]="{'is-invalid-error': complaintForm.get('complainantStreetAddress')?.touched && complaintForm.get('complainantStreetAddress')?.invalid}" />
                    <div
                      *ngIf="complaintForm.get('complainantStreetAddress')?.touched && complaintForm.get('complainantStreetAddress')?.errors as errors">
                      <div *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0018'] }}
                      </div>
                      <div role="alert" *ngIf="errors['specialCharAtEnd']" class="text-danger mt-1 err-font">
                        {{ errorMessage['M0052'] }}
                      </div>
                      <div
                        *ngIf="!errors['required'] && !errors['specialCharAtEnd'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                        class="text-danger mt-1 err-font">
                        {{ errorMessage['M0052'] }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-3 d-flex flex-column pl-1 responsive-col">
                    <div class="form-label">City<span class="text-red">*</span></div>
                    <input class="form-control " [placeholder]="placeholderMessage['P0013']"
                      formControlName="complainantCity" type="text" id="input_raiseacomplaint_complainant_city"
                      tabindex="0" required aria-label="Complainant City" (keydown.enter)="$event.preventDefault()"
                      [ngClass]="{'is-invalid-error': complaintForm.get('complainantCity')?.touched && complaintForm.get('complainantCity')?.invalid}"
                      minlength="2" maxlength="60" />
                    <!-- <div
                      *ngIf="complaintForm.get('complainantCity')?.invalid && (complaintForm.get('complainantCity')?.touched || complaintForm.get('complainantCity')?.dirty)"
                      class="text-danger small">City is required.</div> -->
                    <div
                      *ngIf="complaintForm.get('complainantCity')?.invalid && complaintForm.get('complainantCity')?.touched && complaintForm.get('complainantCity')?.errors as errors">
                      <div *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0019'] }}
                      </div>
                      <div role="alert" *ngIf="errors['specialCharAtEnd']" class="text-danger mt-1 err-font">
                        {{ errorMessage['M0050'] }}
                      </div>
                      <div
                        *ngIf="!errors['required'] && !errors['specialCharAtEnd'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                        class="text-danger mt-1 err-font">
                        {{ errorMessage['M0050'] }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-3 d-flex flex-column pl-1 responsive-col">
                    <div class="form-label">State<span class="text-red">*</span></div>
                    <div class="dropdown-clear-wrapper">
                      <p-dropdown #stateSelected id="select_raiseacomplaint_complainant_state"
                        formControlName="complainantState" [options]="stateList"
                        styleClass="custom-dropdown-border form-control" placeholder="Select State" required
                        tabindex="0" aria-required="true"
                        [attr.aria-invalid]="complaintForm.get('complainantState')?.touched && complaintForm.get('complainantState')?.invalid ? 'true' : null"
                        [attr.aria-describedby]="complaintForm.get('complainantState')?.touched && complaintForm.get('complainantState')?.invalid ? 'complainantState-error' : null"
                        (keydown.enter)="$event.preventDefault()" [ngClass]="{
                                        'is-invalid-errorr': complaintForm.get('complainantState')?.touched && complaintForm.get('complainantState')?.invalid,
                                        'placeholder-color': complaintForm.get('complainantState')?.value === null,
                                        'selected-color': complaintForm.get('complainantState')?.value !== null
                                      }" />
                      <!-- <button *ngIf="complaintForm.get('complainantState')?.value" type="button"
                        id="btn_complaintForm_clear_state" class="clear-icon" tabindex="-1"
                        (click)="clearState(stateSelected,true); $event.stopPropagation()" aria-label="Clear selection">
                        &#10006;
                      </button> -->
                    </div>
                    <div
                      *ngIf="complaintForm.get('complainantState')?.invalid && (complaintForm.get('complainantState')?.touched || complaintForm.get('complainantState')?.dirty)"
                      class="text-danger mt-1 err-font">{{ errorMessage['M0020'] }}</div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-3 d-flex flex-column pl-1 responsive-col">
                    <div class="form-label">ZIP Code<span class="text-red">*</span></div>
                    <input class="form-control " [placeholder]="placeholderMessage['P0016']"
                      formControlName="complainantZip" type="text" tabindex="0"
                      id="input_raiseacomplaint_complainant_zip"
                      (input)="zipCodeFormat($event, 'complainantZip')" minlength="5" maxlength="10" required
                      (keydown.enter)="$event.preventDefault()" [ngClass]="{
                                      'is-invalid-error': complaintForm.get('complainantZip')?.touched && complaintForm.get('complainantZip')?.invalid
                                    }" />
                    <div
                      *ngIf="complaintForm.get('complainantZip')?.touched && complaintForm.get('complainantZip')?.errors as errors">
                      <div *ngIf="errors['required']" class="text-danger mt-1 err-font">{{ errorMessage['M0022'] }}
                      </div>
                      <div *ngIf="errors['allZeros'] || errors['M0023']" class="text-danger mt-1 err-font">{{
                        errorMessage['M0023'] }}
                      </div>
                      <div *ngIf="errors['invalidZipLength']" class="text-danger mt-1 err-font">
                        Zip code must be either 5 digits or 9 digits.
                      </div>
                      <div
                        *ngIf="!errors['required'] && !errors['allZeros'] && !errors['invalidZipLength'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                        class="text-danger mt-1 err-font">
                        {{ errorMessage['M0023'] }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- complainant info start-->
          <!-- complaint details start -->
          <div class="license-wrapper border-box">
            <div class="license-header d-flex justify-content-between align-items-center" (click)="details = !details"
              [ngClass]="{'expanded': details, 'collapsed': !details}">
              <h5 class=" mb-0">Complaint Details</h5>
              <button type="button" class="toggle-btn" aria-label="Toggle" [attr.aria-expanded]="!details"
                (click)="$event.stopPropagation(); details = !details">
                <span class="toggle-icon">
                  <i class="fas fa-chevron-up" *ngIf="details" aria-hidden="true"></i>
                  <i class="fas fa-chevron-down" *ngIf="!details" aria-hidden="true"></i>
                </span>
              </button>
            </div>
            <div *ngIf="details" class="section-body p-3 border-box-section">
              <div>
                <p>Please provide the details of your complaint. Include the educator’s name, the date(s), time(s),
                  and a clear description of the alleged violation or concern. Provide as much information as you can
                  to help the Department understand and investigate the issue.</p>
              </div>
              <div class="mb-4">
                <div class="row mb-3 mr-2 responsive-row">
                  <div class="col-12 col-md-6 col-lg-3 pl-1 pr-0 d-flex flex-column responsive-col">
                    <div class="form-label ">Date of Incident<span class="text-red">*</span></div>
                    <div class="input-group">
                      <input class="form-control" [placeholder]="placeholderMessage['P0104']" #dateTextInput
                        data-placeholder="MM/DD/YYYY" type="text" id="dateOfComplaint" formControlName="dateOfComplaint"
                        required aria-required="true"
                        [attr.aria-invalid]="complaintForm.get('dateOfComplaint')?.touched && complaintForm.get('dateOfComplaint')?.invalid ? 'true' : null"
                        [attr.aria-describedby]="complaintForm.get('dateOfComplaint')?.touched && complaintForm.get('dateOfComplaint')?.invalid ? 'dateOfComplaint-error' : null"
                        tabindex="0" maxlength="10" appDateMask (dateMaskError)="dateMaskError = $event" 
                        (keydown.enter)="$event.preventDefault()" [ngClass]="{
                    'is-invalid-error': complaintForm.get('dateOfComplaint')?.touched && complaintForm.get('dateOfComplaint')?.invalid,
                    'has-value': !!complaintForm.get('dateOfComplaint')?.value
                  }" />
                      <div class="input-group-append relative">
                        <span class="calendar-input-icon" (click)="startHiddenDateInput.click()">
                          <i class="fa fa-calendar"></i>
                          <input type="date" #startHiddenDateInput (change)="onStartDateChange($event,dateTextInput)"
                            class="calendar-icon" tabindex="-1" [attr.max]="todayString"/>

                        </span>
                      </div>
                    </div>
                    <div
                      *ngIf="complaintForm.get('dateOfComplaint')?.touched && complaintForm.get('dateOfComplaint')?.errors as errors">
                      <div id="dob-error" *ngIf="errors['required']" class="text-danger mt-1 err-font">
                        {{ errorMessage['M0078']}}
                      </div>
                      <div id="dob-error" *ngIf="errors['pattern'] || errors['futureDate']" class="text-danger mt-1 err-font">
                        {{ errorMessage['M0156']}}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-3 pr-0 d-flex flex-column responsive-col">
                    <div class="form-label">Educator Name<span class="text-red">*</span></div>
                    <input class="form-control " [placeholder]="placeholderMessage['P0105']"
                      formControlName="educatorsFirstName" type="text" tabindex="0" id="educatorsFirstName"
                      formControlName="educatorsFirstName" maxlength="30" minlength="2" required
                      aria-label="Enter educators First Name" aria-required="true"
                      [attr.aria-invalid]="complaintForm.get('educatorsFirstName')?.touched && complaintForm.get('educatorsFirstName')?.invalid ? 'true' : null"
                      [attr.aria-describedby]="complaintForm.get('educatorsFirstName')?.touched && complaintForm.get('educatorsFirstName')?.invalid ? 'educatorsFirstName-error' : null"
                      (input)="educatorsFirstName($event)" (blur)="checkForTrailingSpace($event, 'educatorsFirstName')"
                      (keydown.enter)="$event.preventDefault()"
                      [ngClass]="{'is-invalid-error': complaintForm.get('educatorsFirstName')?.touched && complaintForm.get('educatorsFirstName')?.invalid}" />
                    <div *ngIf="
                  complaintForm.get('educatorsFirstName')?.touched && complaintForm.get('educatorsFirstName')?.errors as errors
                ">
                      <div id="educatorsFirstName-error" *ngIf="errors['required']" class="text-danger mt-1 err-font">
                        {{ errorMessage['M0140'] }}</div>
                      <div id="educatorsFirstName-error"
                        *ngIf="!errors['required'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                        class="text-danger mt-1 err-font">
                        {{ errorMessage['M0157'] }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-3">
                  <p>Brief Description of the Alleged Misconduct<span class="text-red">*</span>
                  </p>
                </div>
                <div class=" mb-3 gap_education">
                  <div class="card mt-3" (focusin)="onComplaintEditorInteraction($event)"
                    (click)="onComplaintEditorInteraction($event)">
                    <p-editor *ngIf="placeholderMessage['P0106']" [class.readonly-editor]="viewOnly"
                      [placeholder]="placeholderMessage['P0106']" formControlName="complaintTextData"
                      appWordCountLimit="10" [readonly]="viewOnly" [style]="{'height':'8rem'}"
                      (onTextChange)="onComplaintEditorInteraction($event)"
                      (onBlur)="onComplaintEditorInteraction($event)">
                    </p-editor>
                  </div>
                  <p-message *ngIf="complaintForm.get('complaintTextData')?.invalid && (complaintForm.get('complaintTextData')?.touched || 
                    complaintForm.get('complaintTextData')?.dirty)" class="text-danger small" severity="error"
                    size="small" variant="simple">Description is required.</p-message>
                </div>
              </div>
            </div>
          </div>
          <!-- complaint details end-->
          <!-- Witness info start-->
          <div class="license-wrapper border-box mb-3">
            <div class="license-header d-flex justify-content-between align-items-center"
              (click)="Witnesses = !Witnesses" [ngClass]="{'expanded': Witnesses, 'collapsed': !Witnesses}">
              <h5 class=" mb-0">Witnesses and Supporting Documentation</h5>
              <button type="button" class="toggle-btn" aria-label="Toggle" [attr.aria-expanded]="!Witnesses"
                (click)="$event.stopPropagation(); Witnesses = !Witnesses">
                <span class="toggle-icon">
                  <i class="fas fa-chevron-up" *ngIf="Witnesses" aria-hidden="true"></i>
                  <i class="fas fa-chevron-down" *ngIf="!Witnesses" aria-hidden="true"></i>
                </span>
              </button>
            </div>
            <div *ngIf="Witnesses" class="section-body p-3 border-box-section">
              <div>
                <p>List any witnesses or other individuals who have knowledge of the events described in your
                  complaint. Include their contact information and a brief statement if available. You may also upload
                  any documents, photos, or other evidence that supports your complaint.</p>
              </div>
              <form [formGroup]="witnessesForm">
                <div class="mb-4">
                  <div class="row mb-3 mr-2  witness-row-responsive">
                    <div class="col-12 col-md-6 col-lg pl-1 pr-0 d-flex flex-column witness-col-responsive">
                      <div class="form-label">Witness Name<span class="text-red">*</span></div>
                      <input class="form-control " [placeholder]="placeholderMessage['P0107']"
                        formControlName="witnessesName" type="text" tabindex="0" id="witnessesName" maxlength="30"
                        minlength="2" required aria-label="Enter Witness Name" aria-required="true"
                        [attr.aria-invalid]="witnessesForm.get('witnessesName')?.touched && witnessesForm.get('witnessesName')?.invalid ? 'true' : null"
                        [attr.aria-describedby]="witnessesForm.get('witnessesName')?.touched && witnessesForm.get('witnessesName')?.invalid ? 'witnessesName-error' : null"
                        (input)="witnessesName($event, 'main')" (blur)="checkForTrailingSpace($event, 'witnessesName')"
                        [ngClass]="{'is-invalid-error': witnessesForm.get('witnessesName')?.touched && witnessesForm.get('witnessesName')?.invalid}" />
                      <div
                        *ngIf="witnessesForm.get('witnessesName')?.invalid && (witnessesForm.get('witnessesName')?.touched || witnessesForm.get('witnessesName')?.dirty)"
                        class="text-danger small">
                        <div *ngIf="witnessesForm.get('witnessesName')?.errors?.required"
                          class="text-danger mt-1 err-font">{{ errorMessage['M0140'] }}</div>
                        <div
                          *ngIf="!witnessesForm.get('witnessesName')?.errors?.required && (witnessesForm.get('witnessesName')?.errors?.pattern || witnessesForm.get('witnessesName')?.errors?.minlength || witnessesForm.get('witnessesName')?.errors?.maxlength)"
                          class="text-danger mt-1 err-font">{{ errorMessage['M0157'] }}</div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg pr-0 d-flex flex-column witness-col-responsive">
                      <div class="form-label">Witness Email Address<span class="text-red"></span></div>
                      <input class="form-control " [placeholder]="placeholderMessage['P0108']"
                        formControlName="witnessesEmail" />
                      <div
                        *ngIf="witnessesForm.get('witnessesEmail')?.invalid && witnessesForm.get('witnessesEmail')?.errors as errors">
                        <div
                          *ngIf="witnessesForm.get('witnessesEmail')?.invalid && witnessesForm.get('witnessesEmail')?.errors as errors">
                          <div *ngIf="errors['email'] || errors['pattern']" class="text-danger mt-1 err-font">{{
                            errorMessage['M0015'] }}</div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg pr-0 d-flex flex-column witness-col-responsive">
                      <div class="form-label">Witness Phone Number<span class="text-red"></span></div>
                      <input class="form-control " [placeholder]="placeholderMessage['P0109']"
                        formControlName="witnessesPhone" id="witnessesPhone" aria-required="true"
                        [attr.aria-invalid]="witnessesForm.get('witnessesPhone')?.touched && witnessesForm.get('witnessesPhone')?.invalid ? 'true' : null"
                        [attr.aria-describedby]="witnessesForm.get('witnessesPhone')?.touched && witnessesForm.get('witnessesPhone')?.invalid ? 'witnessesPhone-error' : null"
                        tabindex="0" (input)="formatWitnessPhoneNumber($event)" (focus)="isPhoneFocused = true"
                        (blur)="isPhoneFocused = false; checkPhone()" numbersOnly [ngClass]="{
                  'is-invalid-error':
                    witnessesForm.get('witnessesPhone')?.touched && witnessesForm.get('witnessesPhone')?.invalid
                }" />
                      <div
                        *ngIf="witnessesForm.get('witnessesPhone')?.touched && witnessesForm.get('witnessesPhone')?.invalid && witnessesForm.get('witnessesPhone')?.errors as errors">
                        <div *ngIf="errors['M0022'] || errors['pattern']" class="text-danger mt-1 err-font">{{
                          errorMessage['M0017'] }}</div>
                        <div *ngIf="errors['maxlength']" class="text-danger mt-1 err-font">Phone number is too long.
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg pr-0 d-flex flex-column witness-col-responsive">
                      <div class="form-label">Street Address<span class="text-red"></span></div>
                      <input class="form-control " [placeholder]="placeholderMessage['P0011']"
                        formControlName="witnessesAddress" minlength="3" maxlength="60" />
                      <div
                        *ngIf="witnessesForm.get('witnessesAddress')?.invalid && witnessesForm.get('witnessesAddress')?.errors as errors">
                        <div *ngIf="errors['pattern']" class="text-danger mt-1 err-font">{{ errorMessage['M0052'] }}
                        </div>
                        <div *ngIf="errors['minlength'] || errors['maxlength']" class="text-danger mt-1 err-font">{{
                          errorMessage['M0052'] }}</div>
                        <div *ngIf="errors['M0052']" class="text-danger mt-1 err-font">{{ errorMessage['M0052'] }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex mb-3 flex-wrap witness-row-responsive">
                    <div class="col-12 col-md-6 col-lg-3 d-flex flex-column pl-1 witness-col-responsive">
                      <div class="form-label">City<span class="text-red"></span></div>
                      <input class="form-control " [placeholder]="placeholderMessage['P0013']"
                        formControlName="witnessesCity" minlength="2" maxlength="60" />
                      <div
                        *ngIf="witnessesForm.get('witnessesCity')?.invalid && witnessesForm.get('witnessesCity')?.errors as errors">
                        <div *ngIf="errors['pattern']" class="text-danger mt-1 err-font">{{ errorMessage['M0050'] }}
                        </div>
                        <div *ngIf="errors['M0050']" class="text-danger mt-1 err-font">{{ errorMessage['M0050'] }}</div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3 d-flex flex-column pl-1 witness-col-responsive">
                      <div class="form-label">State</div>
                      <div class="dropdown-clear-wrapper">
                        <p-dropdown #witnessStateSelected id="witnessesState" formControlName="witnessesState"
                          [options]="stateList" styleClass="form-control" placeholder="Enter State" tabindex="0"
                          aria-required="false"
                          [attr.aria-describedby]="witnessesForm.get('witnessesState')?.invalid ? 'witnessesState-error' : null"
                          [ngClass]="witnessesForm.get('witnessesState')?.value === null ? 'placeholder-color' : 'selected-color'" />
                        <!-- <button *ngIf="witnessesForm.get('witnessesState')?.value" type="button"
                          id="btn_complaintForm_clear_state" class="clear-icon" tabindex="-1"
                          (click)="clearState(witnessStateSelected,false); $event.stopPropagation()"
                          aria-label="Clear selection">
                          &#10006;
                        </button> -->
                      </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3 d-flex flex-column pl-1 witness-col-responsive">
                      <div class="form-label">ZIP Code</div>
                      <div class="input-group">
                        <input class="form-control" [placeholder]="placeholderMessage['P0016']" type="text"
                          formControlName="witnessesZip" (input)="zipCodeFormat($event, 'witnessesZip')"
                          [attr.aria-invalid]="witnessesForm.get('witnessesZip')?.touched && witnessesForm.get('witnessesZip')?.invalid ? 'true' : null"
                          [attr.aria-describedby]="witnessesForm.get('witnessesZip')?.touched && witnessesForm.get('witnessesZip')?.invalid ? 'witnessesZip-error' : null"
                          [ngClass]="{'is-invalid-error': witnessesForm.get('witnessesZip')?.touched && witnessesForm.get('witnessesZip')?.invalid}" />
                      </div>
                      <div
                        *ngIf="witnessesForm.get('witnessesZip')?.invalid && witnessesForm.get('witnessesZip')?.errors as errors">
                        <div *ngIf="errors['M0023']" class="text-danger mt-1 err-font">{{ errorMessage['M0023'] }}
                        </div>
                      </div>
                      <!-- <div
                        *ngIf="witnessesForm.get('witnessesZip')?.invalid && witnessesForm.get('witnessesZip')?.errors as errors">
                        <div
                          *ngIf="witnessesForm.get('witnessesZip')?.invalid && witnessesForm.get('witnessesZip')?.errors as errors">
                          <div *ngIf="errors['M0023']" class="text-danger mt-1 err-font">{{
                            errorMessage['M0023'] }}</div>
                        </div>
                      </div> -->
                    </div>
                  </div>
                  <div class="mt-3">
                    <p>Additional Information</p>
                  </div>
                  <div class="d-flex mt-3">
                    <div class="card w-100">
                      <p-editor *ngIf="placeholderMessage['P0110']" [class.readonly-editor]="viewOnly"
                        [placeholder]="placeholderMessage['P0110']" formControlName="witnessesTextData"
                        appWordCountLimit="10" [readonly]="viewOnly" [style]="{'height':'8rem'}" class="w-100">
                      </p-editor>
                      <div
                        *ngIf="witnessesForm.get('witnessesTextData')?.touched && witnessesForm.get('witnessesTextData')?.errors as errors">
                        <div *ngIf="errors['maxlength']" class="text-danger mt-1 err-font">Statement is too long.</div>
                      </div>
                    </div>

                  </div>
                  <div class="d-flex justify-content-end licenseactions pl-3 mt-1">
                    <button class="btn-cancel btn text-right py-1 height_btn" tooltipPosition="bottom"
                      (click)="resetData()" [disabled]="!formTouched">Reset</button>
                    <button type="button" class="btn btn-primary grid rounded btn-add height_btn"
                      [disabled]="witnessesForm.invalid" (click)="addData()" aria-label="Add" tooltipPosition="bottom">
                      <i class="pi pi-plus-circle"></i> Add</button>
                  </div>
                </div>
              </form>
              <!-- witness data grid -->
              <div class="column-chooser-actions mb-2 d-flex justify-content-end">
                <button mat-icon-button class="icon-btn" matTooltip="Column Chooser" matTooltipPosition="above"
                  matTooltipClass="custom-tooltip" (click)="showColumnChooser = !showColumnChooser"
                  id="dashboard_column_chooser_btn">
                  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M4.30775 18H8.3365V6H4.30775C4.21792 6 4.14417 6.02883 4.0865 6.0865C4.02883 6.14417 4 6.21792 4 6.30775V17.6923C4 17.7821 4.02883 17.8558 4.0865 17.9135C4.14417 17.9712 4.21792 18 4.30775 18ZM9.8365 18H14.1635V6H9.8365V18ZM15.6635 18H19.6923C19.7821 18 19.8558 17.9712 19.9135 17.9135C19.9712 17.8558 20 17.7821 20 17.6923V6.30775C20 6.21792 19.9712 6.14417 19.9135 6.0865C19.8558 6.02883 19.7821 6 19.6923 6H15.6635V18ZM4.30775 19.5C3.80258 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.1974 2.5 17.6923V6.30775C2.5 5.80258 2.675 5.375 3.025 5.025C3.375 4.675 3.80258 4.5 4.30775 4.5H19.6923C20.1974 4.5 20.625 4.675 20.975 5.025C21.325 5.375 21.5 5.80258 21.5 6.30775V17.6923C21.5 18.1974 21.325 18.625 20.975 18.975C20.625 19.325 20.1974 19.5 19.6923 19.5H4.30775Z"
                      fill="currentColor" />
                  </svg>

                </button>
                <div *ngIf="showColumnChooser" class="column-chooser-dialog" id="dashboard_column_chooser_dialog">
                  <div class="column-chooser-header">
                    Column Chooser
                    <button class="column-chooser-close" (click)="closeColumnChooser()"
                      id="dashboard_column_chooser_close">&times;</button>
                  </div>
                  <div class="column-chooser-list">
                    <label *ngFor="let col of allColumns; let i = index" class="column-chooser-checkbox"
                      [id]="'dashboard_column_' + col.dataField">
                      <input type="checkbox"
                        (change)="onColumnVisibilityChange(col.dataField, $event.target.checked, col, i)"
                        [checked]="visibleColumns[col.dataField]" [disabled]="col.dataField === disableAppIdColumn" />
                      {{ col.label }}
                    </label>
                  </div>
                </div>
              </div>
              <app-data-grid [onApplicationClick]="onApplicationIdClick" [config]="witnessesDataGridConfig"
                [attr.data-key]="witnessesDataGridConfig._changeKey" [actionsTemplateRef]="dashboardActionTemplate"
                id="dashboard_grid_datagrid" class="no-border-grid">
                <ng-template #dashboardActionTemplate let-row let-index="index">
                  <div class="action-buttons-container d-flex gap_action"
                    [id]="'dashboard_div_actions_' + row.application_id">
                    <div class="action-inline ml-4">
                      <div class="action-flex">
                        <button type="button" class="action-icon-button" matTooltip="Edit" matTooltipPosition="above"
                          (click)="openEditWitnessModal(row, getWitnessRowIndex(row))">
                          <svg width="24" height="24" viewBox="4 4 26 26" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M10.3077 25.501C9.80258 25.501 9.375 25.326 9.025 24.976C8.675 24.626 8.5 24.1984 8.5 23.6933V10.3087C8.5 9.80358 8.675 9.376 9.025 9.026C9.375 8.676 9.80258 8.501 10.3077 8.501H17.1598C17.4098 8.501 17.5973 8.5795 17.7223 8.7365C17.8473 8.89367 17.9098 9.06517 17.9098 9.251C17.9098 9.43683 17.8447 9.60833 17.7145 9.7655C17.5843 9.9225 17.3942 10.001 17.1442 10.001H10.3077C10.2307 10.001 10.1603 10.0331 10.0963 10.0972C10.0321 10.1612 10 10.2317 10 10.3087V23.6933C10 23.7703 10.0321 23.8407 10.0963 23.9047C10.1603 23.9689 10.2307 24.001 10.3077 24.001H23.6923C23.7692 24.001 23.8398 23.9689 23.9038 23.9047C23.9679 23.8407 24 23.7703 24 23.6933V16.7933C24 16.5433 24.0785 16.3558 24.2355 16.2308C24.3927 16.1058 24.5642 16.0433 24.75 16.0433C24.9358 16.0433 25.1073 16.1058 25.2645 16.2308C25.4215 16.3558 25.5 16.5433 25.5 16.7933V23.6933C25.5 24.1984 25.325 24.626 24.975 24.976C24.625 25.326 24.1974 25.501 23.6923 25.501H10.3077ZM14.5 18.597V16.8165C14.5 16.5753 14.5468 16.3436 14.6405 16.1212C14.734 15.8987 14.8628 15.7055 15.027 15.5415L23.5598 7.00875C23.7148 6.85358 23.8853 6.74042 24.0712 6.66925C24.2571 6.59808 24.4462 6.5625 24.6385 6.5625C24.8347 6.5625 25.0231 6.59808 25.2038 6.66925C25.3846 6.74042 25.5493 6.85033 25.698 6.999L26.9538 8.251C27.0986 8.40617 27.2098 8.57733 27.2875 8.7645C27.365 8.95167 27.4038 9.14142 27.4038 9.33375C27.4038 9.52608 27.3708 9.71258 27.3048 9.89325C27.2388 10.0741 27.1282 10.242 26.973 10.397L18.4115 18.9587C18.2473 19.1227 18.0541 19.2542 17.8318 19.353C17.6093 19.4517 17.3775 19.501 17.1365 19.501H15.404C15.1462 19.501 14.9311 19.4147 14.7588 19.2422C14.5863 19.0699 14.5 18.8548 14.5 18.597ZM16 18.001H17.2463L23.4788 11.7682L22.8558 11.1452L22.1885 10.503L16 16.6915V18.001Z"
                              fill="#444444" />
                          </svg>
                        </button>
                        <!-- Delete button only for draft applications -->
                        <button mat-icon-button class="action-icon-button ml-2" matTooltip="Delete"
                          matTooltipPosition="above" matTooltipClass="custom-tooltip"
                          (click)="deleteWitnessRow(getWitnessRowIndex(row))"
                          [id]="'dashboard_delete_row_' + row.application_id">
                          <img src="../../assets/images/neveda-images/delete-icon.svg" alt="Delete" width="24"
                            height="24" class="filter-icon">
                        </button>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </app-data-grid>
              <!-- witness data grid -->
              <!-- supporting documents data grid -->
              <hr class="horizontal-line" />
              <div class="row header-row justify-content-between align-items-center mt-3 mb-3">
                <div class="w-padding">
                  <h6 class="document-grid-title" id="dashboard_title">Supporting Documents</h6>
                </div>
                <div class="col-auto">
                  <div class="actions d-flex">
                    <div class="export-actions">
                    </div>
                    <div class="column-chooser-actions">
                      <button mat-icon-button class="icon-btn" matTooltip="Column Chooser" matTooltipPosition="above"
                        matTooltipClass="custom-tooltip"
                        (click)="showSupportingColumnChooser = !showSupportingColumnChooser"
                        id="dashboard_column_chooser_btn">
                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none">
                          <path
                            d="M4.30775 18H8.3365V6H4.30775C4.21792 6 4.14417 6.02883 4.0865 6.0865C4.02883 6.14417 4 6.21792 4 6.30775V17.6923C4 17.7821 4.02883 17.8558 4.0865 17.9135C4.14417 17.9712 4.21792 18 4.30775 18ZM9.8365 18H14.1635V6H9.8365V18ZM15.6635 18H19.6923C19.7821 18 19.8558 17.9712 19.9135 17.9135C19.9712 17.8558 20 17.7821 20 17.6923V6.30775C20 6.21792 19.9712 6.14417 19.9135 6.0865C19.8558 6.02883 19.7821 6 19.6923 6H15.6635V18ZM4.30775 19.5C3.80258 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.1974 2.5 17.6923V6.30775C2.5 5.80258 2.675 5.375 3.025 5.025C3.375 4.675 3.80258 4.5 4.30775 4.5H19.6923C20.1974 4.5 20.625 4.675 20.975 5.025C21.325 5.375 21.5 5.80258 21.5 6.30775V17.6923C21.5 18.1974 21.325 18.625 20.975 18.975C20.625 19.325 20.1974 19.5 19.6923 19.5H4.30775Z"
                            fill="currentColor" />
                        </svg>
                      </button>
                      <div *ngIf="showSupportingColumnChooser" class="column-chooser-dialog"
                        id="dashboard_column_chooser_dialog">
                        <div class="column-chooser-header">
                          Column Chooser
                          <button class="column-chooser-close" (click)="closeColumnChooser()"
                            id="dashboard_column_chooser_close">&times;</button>
                        </div>
                        <div class="column-chooser-list">
                          <label *ngFor="let col of allSupportingColumns; let i = index" class="column-chooser-checkbox"
                            [id]="'dashboard_column_' + col.dataField">
                            <input type="checkbox"
                              (change)="onSupportingColumnVisibilityChange(col.dataField, $event.target.checked, col, i)"
                              [checked]="visibleSupportingColumns[col.dataField]"
                              [disabled]="col.dataField === disableAppIdColumn" />
                            {{ col.label }}
                          </label>
                        </div>
                      </div>
                    </div>
                    <button type="button" class="btn btn-primary grid rounded upload-btn ml-2" aria-label="Upload"
                      pRipple icon="pi pi-plus" [pTooltip]="buttonLabel ? buttonLabel : 'Upload'"
                      tooltipPosition="bottom" (click)="showUploadModal(uploadModel)"><img class="mr-2 width-20"
                        src="../../../../assets/images/neveda-images/upload.svg" alt="" srcset="">Upload</button>
                  </div>
                </div>
              </div>
              <app-data-grid [onApplicationClick]="onApplicationIdClick" [config]="supportingWitnessesDataGrid"
                [actionsTemplateRef]="dashboardActionTemplate1" id="dashboard_grid_datagrid">
                <ng-template #dashboardActionTemplate1 let-row let-index="index">
                  <div class="action-buttons-container d-flex gap_action">
                    <div class="action-inline ml-4">
                      <div class="action-flex">
                        <button mat-icon-button class="action-icon-button" matTooltip="Download"
                          matTooltipPosition="above" matTooltipClass="custom-tooltip"
                          (click)="downloadSupportingDocument(row)"
                          [id]="'dashboard_open_row_download_dialog_' + row.strFileName">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                            fill="none">
                            <path
                              d="M12 15.4115C11.8795 15.4115 11.7673 15.3923 11.6635 15.3538C11.5597 15.3154 11.4609 15.2494 11.3672 15.1558L8.25775 12.0463C8.10908 11.8974 8.03567 11.7233 8.0375 11.524C8.0395 11.3247 8.11292 11.1474 8.25775 10.9922C8.41292 10.8373 8.59108 10.7572 8.79225 10.752C8.99358 10.7468 9.17183 10.8218 9.327 10.977L11.25 12.9V5.25C11.25 5.03717 11.3218 4.859 11.4655 4.7155C11.609 4.57183 11.7872 4.5 12 4.5C12.2128 4.5 12.391 4.57183 12.5345 4.7155C12.6782 4.859 12.75 5.03717 12.75 5.25V12.9L14.673 10.977C14.8218 10.8283 14.9984 10.7549 15.2028 10.7568C15.4072 10.7588 15.5871 10.8373 15.7423 10.9922C15.8871 11.1474 15.9621 11.3231 15.9672 11.5192C15.9724 11.7154 15.8974 11.8911 15.7423 12.0463L12.6328 15.1558C12.5391 15.2494 12.4403 15.3154 12.3365 15.3538C12.2327 15.3923 12.1205 15.4115 12 15.4115ZM6.30775 19.5C5.80258 19.5 5.375 19.325 5.025 18.975C4.675 18.625 4.5 18.1974 4.5 17.6923V15.7308C4.5 15.5179 4.57183 15.3398 4.7155 15.1962C4.859 15.0526 5.03717 14.9808 5.25 14.9808C5.46283 14.9808 5.641 15.0526 5.7845 15.1962C5.92817 15.3398 6 15.5179 6 15.7308V17.6923C6 17.7692 6.03208 17.8398 6.09625 17.9038C6.16025 17.9679 6.23075 18 6.30775 18H17.6923C17.7692 18 17.8398 17.9679 17.9038 17.9038C17.9679 17.8398 18 17.7692 18 17.6923V15.7308C18 15.5179 18.0718 15.3398 18.2155 15.1962C18.359 15.0526 18.5372 14.9808 18.75 14.9808C18.9628 14.9808 19.141 15.0526 19.2845 15.1962C19.4282 15.3398 19.5 15.5179 19.5 15.7308V17.6923C19.5 18.1974 19.325 18.625 18.975 18.975C18.625 19.325 18.1974 19.5 17.6923 19.5H6.30775Z"
                              fill="currentColor" />
                          </svg>
                        </button>
                        <button mat-icon-button class="action-icon-button ml-2" matTooltip="Delete"
                          matTooltipPosition="above" matTooltipClass="custom-tooltip"
                          (click)="deleteSupportingDocumentRow(row)" [id]="'dashboard_delete_row_' + row.strFileName">
                          <img src="../../assets/images/neveda-images/delete-icon.svg" alt="Delete" class="filter-icon">
                        </button>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </app-data-grid>
              <!-- supporting documents data grid -->
            </div>
          </div>
          <!-- witness info end-->
          <!-- Acknowledgement start -->
          <div class="license-wrapper border-box">
            <div class="license-header d-flex justify-content-between align-items-center"
              (click)="acknowledgement = !acknowledgement"
              [ngClass]="{'expanded': acknowledgement, 'collapsed': !acknowledgement}">
              <h5 class=" mb-0">Complaint Acknowledgement</h5>
              <button type="button" class="toggle-btn" aria-label="Toggle" [attr.aria-expanded]="!acknowledgement"
                (click)="$event.stopPropagation(); acknowledgement = !acknowledgement">
                <span class="toggle-icon">
                  <i class="fas fa-chevron-up" *ngIf="acknowledgement" aria-hidden="true"></i>
                  <i class="fas fa-chevron-down" *ngIf="!acknowledgement" aria-hidden="true"></i>
                </span>
              </button>
            </div>
            <div *ngIf="acknowledgement" class="section-body p-3 border-box-section">
              <div class="row check-icon">
                <div class="col-12 form-group clearfix clsMin-23">
                  <div class="checkbox">
                    <div class="row">
                      <div>
                        <input type="checkbox" id="input_registration_form_terms" formControlName="conditions"
                          class="mb-2 mr-1 check-box checkbox-size" required aria-required="true"
                          [attr.aria-describedby]="complaintForm.get('conditions')?.touched && complaintForm.get('conditions')?.invalid ? 'conditions-error' : null" />
                      </div>
                      <div class="col-11 pl-0">
                        <label for="input_registration_form_terms" class="form-check-label mb-0"
                          (click)="$event.preventDefault()" (keypress)="$event.preventDefault()">
                          I attest that the statements I am submitting are true and accurate. I understand that this complaint may result in significant professional actions, up to and including dismissal of the licensed educator named. I further acknowledge that knowingly submitting false information may subject me to criminal enforcement.
                          <span class="requiredfield text-danger">*</span>
                        </label>
                      </div>
                      <div
                        *ngIf="complaintForm.get('conditions')?.touched && complaintForm.get('conditions')?.errors as errors"
                        class="">
                        <div id="conditions-error" *ngIf="errors['required']" class="text-danger mt-1 err-font">You
                          must agree to proceed.</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Acknowledgement end-->
          <hr class="horizontal-line mt-4" />
          <div class="form-group responsive-submit-group">
            <button type="submit" class="btn btn-primary float-md-right mb-3 rounded responsive-submit-btn"
              [disabled]="complaintForm.invalid" (click)="onSubmit()">Submit</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- Delete Modal -->
<div *ngIf="showDeleteModal" class="delete-modal" id="dashboard_delete_modal">
  <div class="modal-content">
    <div class="modal-header">      
      <h6 class="w-100 text-start font-weight-bold mb-0">Delete Record</h6>
      <img src="assets/images/neveda-images/close.svg" id="close_img" alt="close_icon" (click)="closeDeleteModal()" class="pt-1">
    </div>
    <div class="modal-body">
      <div class="modal-content-wrapper">
        <div class="template-content">Are you sure you want to delete this record? This action cannot be undone.</div>
      </div>
    </div>
    <div class="modal-footer">
      <div class="flex-fill">
        <button class="btn w-50 btn-outline" (click)="closeDeleteModal()">Cancel</button>
        <button class="btn w-50 btn-danger btn-radius" (click)="confirmDeleteWitnessRow()">Delete</button>
      </div>
    </div>
  </div>
</div>
<!-- witness Edit Form (show only when editing) -->
<ng-template #editWitnessModal let-modal>
  <div class="custom-ngb-modal">
    <form [formGroup]="editWitnessesForm">
      <div class="modal-header">
        <h4 class="modal-title">Edit Record</h4>
        <button type="button" class="close activities-modal-dismiss" aria-labelledby="lookup-edit-prior-title" (click)="closeModal()" (keypress)="closeModal()" aria-label="Close" tabindex="0">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="exam-edit-form-wrapper mb-3">
          <div class="mb-4">
            <div class="row mb-3 mr-2">
              <div class="col pr-0 d-flex flex-column">
                <div class="form-label">Witness Name<span class="text-red">*</span></div>
                <input class="form-control " [placeholder]="placeholderMessage['P0107']" formControlName="witnesseName"
                  type="text" tabindex="0" id="editModalWitnessesName" maxlength="30" minlength="2" required
                  aria-label="Enter Witness Name" aria-required="true"
                  [attr.aria-invalid]="editWitnessesForm.get('witnesseName')?.touched && editWitnessesForm.get('witnesseName')?.invalid ? 'true' : null"
                  [attr.aria-describedby]="editWitnessesForm.get('witnesseName')?.touched && editWitnessesForm.get('witnesseName')?.invalid ? 'witnessesName-error' : null"
                  (input)="witnessesName($event, 'modal')" (blur)="checkForTrailingSpace($event, 'witnesseName')"
                  [ngClass]="{'is-invalid-error': editWitnessesForm.get('witnesseName')?.touched && editWitnessesForm.get('witnesseName')?.invalid}" />
                <div
                  *ngIf="editWitnessesForm.get('witnesseName')?.invalid && (editWitnessesForm.get('witnesseName')?.touched || editWitnessesForm.get('witnesseName')?.dirty)"
                  class="text-danger small">
                  <div *ngIf="editWitnessesForm.get('witnesseName')?.errors?.required"
                    class="text-danger mt-1 err-font">{{ errorMessage['M0140'] }}</div>
                  <div
                    *ngIf="!editWitnessesForm.get('witnesseName')?.errors?.required && (editWitnessesForm.get('witnesseName')?.errors?.pattern || editWitnessesForm.get('witnesseName')?.errors?.minlength || editWitnessesForm.get('witnesseName')?.errors?.maxlength)"
                    class="text-danger mt-1 err-font">{{ errorMessage['M0157'] }}</div>
                </div>
              </div>
              <div class="col pr-0 d-flex flex-column">
                <div class="form-label">Witness Email Address<span class="text-red"></span></div>
                <input class="form-control " [placeholder]="placeholderMessage['P0108']"
                  formControlName="witnessesEmail" />
                <div
                  *ngIf="editWitnessesForm.get('witnessesEmail')?.touched && editWitnessesForm.get('witnessesEmail')?.errors as errors">
                  <div *ngIf="errors['email']" class="text-danger mt-1 err-font">{{ errorMessage['M0015'] }}</div>
                  <div *ngIf="errors['pattern']" class="text-danger mt-1 err-font">{{ errorMessage['M0015'] }}</div>
                </div>
              </div>
              <div class="col pr-0 d-flex flex-column">
                <div class="form-label">Witness Phone Number<span class="text-red"></span></div>
                <input class="form-control " [placeholder]="placeholderMessage['P0109']"
                  formControlName="witnessesPhone" id="witnessesPhone" aria-required="true"
                  [attr.aria-invalid]=" editWitnessesForm.get('witnessesPhone')?.invalid || phoneExists ? 'true' : null"
                  [attr.aria-describedby]=" editWitnessesForm.get('witnessesPhone')?.invalid || phoneExists ? 'witnessesPhone-error' : null"
                  tabindex="0" (input)="formatEditWitnessPhoneNumber($event)" (focus)="isPhoneFocused = true"
                  (blur)="isPhoneFocused = false; checkPhone()" numbersOnly [ngClass]="{
                  'is-invalid-error':
                    editWitnessesForm.get('witnessesPhone')?.invalid || (phoneExists && !isPhoneFocused)
                }" />
                <div
                  *ngIf="editWitnessesForm.get('witnessesPhone')?.invalid && editWitnessesForm.get('witnessesPhone')?.errors as errors">
                  <div *ngIf="errors['pattern']" class="text-danger mt-1 err-font">{{ errorMessage['M0017'] }}</div>
                </div>
              </div>
              <div class="col pr-0 d-flex flex-column">
                <div class="form-label">Street Address<span class="text-red"></span></div>
                <input class="form-control " [placeholder]="placeholderMessage['P0011']"
                  formControlName="witnessesAddress" minlength="3" maxlength="60" />
                <div
                  *ngIf="editWitnessesForm.get('witnessesAddress')?.touched && editWitnessesForm.get('witnessesAddress')?.errors as errors">
                  <div *ngIf="errors['pattern'] || errors['minlength'] || errors['maxlength']"
                    class="text-danger mt-1 err-font">Please enter a valid address.</div>
                </div>
              </div>
            </div>
            <div class="d-flex mb-3">
              <div class="col-lg-3 col-md-3 col-sm-3 d-flex flex-column pl-1">
                <div class="form-label">City<span class="text-red"></span></div>
                <input class="form-control " [placeholder]="placeholderMessage['P0013']" formControlName="witnessesCity"
                  minlength="2" maxlength="60" />
                <div
                  *ngIf="editWitnessesForm.get('witnessesCity')?.invalid && editWitnessesForm.get('witnessesCity')?.errors as errors">
                  <div *ngIf="errors['pattern']" class="text-danger mt-1 err-font">{{ errorMessage['M0050'] }}
                  </div>
                  <div *ngIf="errors['M0050']" class="text-danger mt-1 err-font">{{ errorMessage['M0050'] }}</div>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-3 d-flex flex-column pl-1 witness-col-responsive">
                      <div class="form-label">State</div>
                      <div class="dropdown-clear-wrapper">
                        <p-dropdown #editwitnessStateSelected id="witnessesState" formControlName="witnessesState"
                          [options]="stateList" styleClass="form-control" placeholder="Enter State" tabindex="0"
                          aria-required="false"
                          [attr.aria-describedby]="editWitnessesForm.get('witnessesState')?.invalid ? 'witnessesState-error' : null"
                          [ngClass]="editWitnessesForm.get('witnessesState')?.value === null ? 'placeholder-color' : 'selected-color'" />
                        <!-- <button *ngIf="editWitnessesForm.get('witnessesState')?.value" type="button"
                          id="btn_complaintForm_clear_state" class="clear-icon" tabindex="-1"
                          (click)="clearState(editwitnessStateSelected,false,true); $event.stopPropagation()"
                          aria-label="Clear selection">
                          &#10006;
                        </button> -->
                      </div>
                    </div>
              <div class=" col-lg-3 col-md-3 col-sm-3 d-flex flex-column pl-1">
                <div class="form-label">ZIP Code</div>
                <div class="input-group">
                  <input class="form-control" (input)="zipCodeFormat($event, 'witnesseZip')"
                    [placeholder]="placeholderMessage['P0016']" type="text" formControlName="witnesseZip" />
                </div>
                <div
                  *ngIf="editWitnessesForm.get('witnesseZip')?.invalid && editWitnessesForm.get('witnesseZip')?.errors as errors">
                  <div *ngIf="errors['M0023']" class="text-danger mt-1 err-font">{{ errorMessage['M0023'] }}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="modal-footer border-top d-flex gap-2">
        <button type="button" class="btn-cancel btn btn-primary btn-lg py-2 px-4 brdrradius"
          (click)="onEditExamReset(selectedExam)">Reset</button>
        <button type="button" class="btn btn-primary btn-lg btnprimary"
          [disabled]="editWitnessesForm.invalid || editWitnessesForm.pristine || (isChanged$ | async) === false"
          (click)="updatewitness()">Update</button>
      </div>
    </form>
  </div>
</ng-template>

<!-- upload Modal -->
<ng-template #uploadModel let-modal>
  <form #uploadForm="ngForm" novalidate>
    <div class="upload-form-popup">
      <div class="form-modal-header p-4 d-flex justify-content-between">
        <h4 class="modal-title">Upload Files</h4>
        <button type="button" class="close" aria-label="Close" (click)="closeUploadPopup()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="form-modal-body pl-4 pr-4 pt-4 pb-2">
        <div class="mb-3">
          <!-- <label class="col-form-label mb-2">Select File <span class="text-danger">*</span></label> -->
          <div class="upload-drop-area" (click)="fileInputRef.click()" (dragover)="$event.preventDefault()"
            (dragleave)="$event.preventDefault()" (drop)="onDropFile($event)">
            <div class="upload-drop-content">
              <span class="p-button-icon p-button-icon-left pi pi-upload upload"></span>
              <span>Drag &amp; drop or <span class="choose-file-link">choose file</span> to upload</span>
            </div>
            <input type="file" #fileInputRef class="file-input-hidden" (change)="handleFileUpload($event)"
              accept=".pdf,.jpg,.jpeg,.png,.mp4,.mp3" />
          </div>
          <div class="no-file-uploaded mt-20" [ngClass]="!uploadData.file?'no-file-uploaded border-0':''"><i
              *ngIf="!uploadData.file" class="pi pi-file"></i>
            <span *ngIf="uploadData.file" class="text-left border-0">{{ uploadData.file.name }}</span>
            <span *ngIf="!uploadData.file">No file
              uploaded</span>
          </div>
          <div *ngIf="uploadError" class="text-danger small mt-2">{{ uploadError }}</div>
        </div>
        <div class="mb-3 filedetails">
          <p class="filesformat">
            Supported formats: PDF, JPG, JPEG, PNG, MP4, MP3.
          </p>
          <p class="filesformat">
            Maximum size: 15 MB.
          </p>
        </div>
      </div>
      <div class="form-modal-footer p-3 d-flex">
        <button type="button" class="btn-cancel btn  btn-md  px-3 py-1" (click)="closeUploadPopup()">Cancel</button>
        <button lang="en" class="btn btn-primary btn-md rounded ms-2" type="button" name="data[submit]"
          [disabled]="saveEnable" (click)="onSave()" ref="button">Save</button>
      </div>
    </div>

  </form>
</ng-template>